

	import { Component, Prop, Watch } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { Company, DeckSearchRequest, Artist, Pro, Series, Technology, Category } from '@shared/models';

	@Component({})
	export default class DeckFilters extends BaseView {

		@Prop({default: null})
		public searchRequest: DeckSearchRequest;
		public visible: boolean = false;

		@Watch('searchRequest', { immediate: true, deep: true })
		public checkForFilters() {
			this.visible = false;
			if (this.searchRequest?.criteria ||
				this.searchRequest?.pros?.length ||
				this.searchRequest?.companies?.length ||
				this.searchRequest?.artists?.length ||
				this.searchRequest?.categories?.length ||
				this.searchRequest?.technologies?.length ||
				this.searchRequest?.categories.length) {
				this.visible = true;
			}
		}


		public reset() {
			this.scroll.scrollToTop();
			this.searchRequest.pageIndex = 0;
			this.searchRequest.companyIds = this.searchRequest.companies.map((x) => x.id);
			this.searchRequest.technologyIds = this.searchRequest.technologies.map((x) => x.id);
			this.searchRequest.artistIds = this.searchRequest.artists.map((x) => x.id);
			this.searchRequest.proIds = this.searchRequest.pros.map((x) => x.id);
			this.searchRequest.categoryIds = this.searchRequest.categories.map((x) => parseInt(x.id.toString(), null));

			// STORE SELECTED FILTERS IN LOCAL STORAGE
			this.storage.store('deck-filter', this.searchRequest);
			this.$router.push({ name: 'deck-list', query: this.searchRequest.collapse() }).catch(() => { /* INTENTIONALLY EMPTY */ });
		}

		public removeCompany(item: Company) {
			const index = this.searchRequest.companies.indexOf(item);
			if (index > -1) {
				this.searchRequest.companies.splice(index, 1);
			}
			this.reset();
		}

		public removeArtist(item: Artist) {
			const index = this.searchRequest.artists.indexOf(item);
			if (index > -1) {
				this.searchRequest.artists.splice(index, 1);
			}
			this.reset();
		}

		public removePro(item: Pro) {
			const index = this.searchRequest.pros.indexOf(item);
			if (index > -1) {
				this.searchRequest.pros.splice(index, 1);
			}
			this.reset();
		}

		public removeTechnology(item: Technology) {
			const index = this.searchRequest.technologies.indexOf(item);
			if (index > -1) {
				this.searchRequest.technologies.splice(index, 1);
			}
			this.reset();
		}

		public removeSeries(item: Series) {
			const index = this.searchRequest.series.indexOf(item);
			if (index > -1) {
				this.searchRequest.series.splice(index, 1);
			}
			this.reset();
		}

		public removeCategory(item: Category) {
			const index = this.searchRequest.categories.indexOf(item);
			if (index > -1) {
				this.searchRequest.categories.splice(index, 1);
			}
			this.reset();
		}

	}

